import React from 'react';

import * as AppConstants from '../../../app/AppConstants';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

function PayInPersonProcedureDialog(props) {
  const isOpen = props.isOpen;

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={!!props.onClose ? props.onClose : null}
    >
      <DialogTitle id="alert-dialog-title">
        {AppConstants.APPLICATION_PAYMENT_METHOD.INPERSON.NAME}
      </DialogTitle>
      <DialogContent style={{fontSize: 15}}>
        A <b>non-refundable</b> fee of HK$110.00 will be charged for a replacement student identity card.
        <br /><br />
        In order to complete your application, please collect the debit note slip at {
          !props.officeUrl
            ? props.officeCentre
            : <a href={props.officeUrl} target="_blank">{props.officeCentre}</a>
        } and settle the fee at the {
          !props.paymentCounterUrl
            ? "Cashier Counter"
            : <a href={props.paymentCounterUrl} target="_blank">Cashier Counter</a>
        } of the Finance Office.
        <br /><br /> 
        Please retain your payment receipt as you will need to present it, along with your HKID card/Passport/Mainland ID Card, which should tally with the record you registered with PolyU, upon collection of your replacement student identity card.
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PayInPersonProcedureDialog;
